import { defineStore } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";

export const useTooltipsStore = defineStore("tooltips", {
  state: () => ({}),

  getters: {
    getTooltipConfig(state) {
      const that = this;
      return function (payload) {
        const webproductStore = useWebproductStore();
        if (!that.getIsTooltipsActive) {
          return null;
        }
        const data = webproductStore.getWebProductData.tooltips.config;
        if (data[payload]) {
          return parseInt(data[payload]);
        }
        return null;
      };
    },
    getTooltipContent(state) {
      const that = this;
      return function (tooltip) {
        const webproductStore = useWebproductStore();
        if (!that.getIsTooltipsActive) {
          return null;
        }
        const data = webproductStore.getWebProductData.tooltips.data;
        if (data[tooltip]) {
          return data[tooltip];
        }
        return null;
      };
    },
    getIsTooltipsActive(state) {
      const webproductStore = useWebproductStore();
      return webproductStore.getWebProductData.tooltips ? true : false;
    },
    getShowTooltipsInPOV(state) {
      return (
        this.getShowTooltipsInMobile && this.getTooltipConfig("pov_matrix")
      );
    },
    getShowTooltipsInPOHeader(state) {
      return this.getShowTooltipsInMobile && this.getTooltipConfig("po_matrix");
    },
    getShowTooltipsInPOPoptext(state) {
      return (
        this.getShowTooltipsInMobile && this.getTooltipConfig("po_poptext")
      );
    },
    getShowTooltipsInMobile(state) {
      const webproductStore = useWebproductStore();
      if (webproductStore.getIsMobile) {
        return this.getTooltipConfig("mobile");
      }
      return true;
    },
    getShowTooltipsInPOVPoptext(state) {
      const webproductStore = useWebproductStore();
      if (webproductStore.getIsMobile) {
        return false;
      }
      return this.getTooltipConfig("pov_poptext");
    }
  },

  actions: {}
});
